import createEventDetailsSchema from 'src/pages/CreateEvent/createEventDetailsSchema';
import createProgramDetailsSchema from '../createProgramDetailsSchema';
import { TCustomField, TProgramDetailsField, TProgramDetailsInitialValues, TUseUpdateErrors } from '../programDetails.types';
import validateForm from '../validateForm';

const useUpdateErrors = () => {
  const updateErrors = async ({ values, customFields, updateErrorsState, type = 'program' }: TUseUpdateErrors) => {
    const { title, startDate, endDate, stages, stageTitles, startTime, endTime, ...programDetailsFields } = values;
    console.log(values, 'valuesData');

    const programDetails: TProgramDetailsField[] = [];

    try {
      Object.keys(programDetailsFields).forEach((key) => {
        const field = programDetailsFields[key as any];
        programDetails.push(field);
      });
    } catch { }

    const customFieldValues: Record<string, string | boolean> = {};
    Object.keys(programDetailsFields).forEach((fieldKey) => {
      const field: TCustomField =
        programDetailsFields[fieldKey as any];
      const id: string = field?.id;

      customFieldValues[id] = field?.values || '';

      if (field?.type !== 'label') {
        customFieldValues[`${id}-label`] = field?.label || '';
      }
    });

    const schema = type === 'program' ? createProgramDetailsSchema({ fields: customFields }) : createEventDetailsSchema({ fields: customFields })
    let schemaObjectValues: any = { title, startDate, endDate, stages, ...customFieldValues }
    if (type === 'event') {
      schemaObjectValues = { ...schemaObjectValues, startTime, endTime }
    }
    const errors = await validateForm({
      values: schemaObjectValues,
      schema,
      updateErrors: updateErrorsState
    });

    return errors?.length;
  };

  return updateErrors;
};

export default useUpdateErrors;
